import GroupResource from 'api/groups';
import { CenterSpinner } from 'components/common/CenterSpinner';
import TeamGroupForm from 'components/teams/TeamGroupForm';
import routes from 'constants/routes';
import React, { useState } from 'react';
import { Alert, Breadcrumb, Button } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import history from 'utils/history';
import TrackifyToast from 'utils/toast';

const EditTeamGroup: React.FC = () => {
  const { id }: any = useParams();
  const queryClient = useQueryClient();

  let teamGroupAPI = new GroupResource();
  const [errMsg, setErrMsg] = useState<string>('');
  const methods = useForm<any>();

  const teamQuery = useQuery(
    [`team-group${id}-edit`, id],
    () => teamGroupAPI.get(id).then((res) => res.data),
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  );

  const updateTeamGroup = useMutation((data: any) =>
    teamGroupAPI.update(id, data)
  );

  const onSubmit = (data: any) => {
    updateTeamGroup.mutate(data, {
      onSuccess: (res: any) => {
        TrackifyToast.success('Group has been edited');
        queryClient.invalidateQueries('teamGroupList');
        history.push({
          pathname: routes.teams.list,
          search: '?name=groups',
        });
      },
      onError: (error: any) => {
        const errorMessage = error?.response?.data?.error?.details
          ? error?.response?.data?.error?.details[0]?.message
          : error?.response?.data?.error?.message;

        setErrMsg(errorMessage);
      },
    });
  };

  if (teamQuery.isLoading) {
    return <CenterSpinner />;
  }

  if (teamQuery.isError) {
    return <Alert variant="danger">Invalid ID</Alert>;
  }

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href={routes.teams.list}>Team</Breadcrumb.Item>
        <Breadcrumb.Item href={`${routes.teams.list}?name=groups`}>
          Group List
        </Breadcrumb.Item>
        <Breadcrumb.Item>Edit Group</Breadcrumb.Item>
      </Breadcrumb>
      <h2>Edit Group</h2>
      <div className="col-md-8">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            {errMsg && <p className="alert-danger p-2">{errMsg}</p>}
            <TeamGroupForm teamGroupData={teamQuery.data.data} />

            <Button
              variant="primary"
              type="submit"
              style={{ float: 'right' }}
              disabled={methods.formState.isSubmitting}>
              Save
            </Button>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default EditTeamGroup;
